import { StoreModel } from './StoreModel';

export class StoreResultsModel {
  public stores: Array<StoreModel>;
}
